import { Language } from '@smooved/core';

export const options = Object.values(Language).map((value) => ({
    id: `language-${value}`,
    labelResource: `LANGUAGE.${value.toUpperCase()}.LABEL`,
    name: 'language',
    value: value,
}));
